<template>
    <span :class="{ [`-${color}`]: true }">
        <slot/>
    </span>
</template>

<style scoped>
span {
    @apply inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium;
}
span.-gray {
    @apply bg-gray-100 text-gray-800;
}
span.-green {
    @apply bg-green-100 text-green-800;
}
span.-yellow {
    @apply bg-yellow-100 text-yellow-800;
}
span.-blue {
    @apply bg-blue-100 text-blue-800;
}
span.-red {
    @apply bg-red-100 text-red-800;
}
</style>

<script>
const colorSets = ['gray', 'green', 'yellow', 'blue', 'red'];

export default {
    props: {
        color: {
            type: String,
            default: 'gray',
            validator: (value) => colorSets.includes(value),
        },
    },
}
</script>
